import { CLEAR_SITE_DATA } from '../application';
import {
  SET_SITES,
  SET_CREATED_SITE,
  SET_ACTIVE_SITE_ID,
  REMOVE_SITE,
  RECEIVE_MODEL_THUMBNAIL,
} from './actions';

const initialState = {
  sites: [],
  thumbnails: {},
  createdSite: null,
  activeSiteId: null,
  siteSetAt: null,
  sitesLoadedAt: null,
};

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case SET_SITES: {
      const { sites } = action;
      return {
        ...state,
        sites: sites.map(({ layouts = [], ...rest }) => ({
          ...rest,
          layout:
            layouts.length > 0
              ? layouts.toSorted((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))[0]
              : {},
        })),
        sitesLoadedAt: Date.now(),
      };
    }
    case RECEIVE_MODEL_THUMBNAIL: {
      const { modelId, versionId, src } = action;
      const thumbnailKey = `${modelId}/${versionId}`;

      return {
        ...state,
        thumbnails: {
          ...state.thumbnails,
          [thumbnailKey]: src,
        },
      };
    }
    case SET_CREATED_SITE: {
      return { ...state, createdSite: action.createdSite };
    }
    case SET_ACTIVE_SITE_ID: {
      return {
        ...state,
        activeSiteId: action.siteId,
        siteSetAt: Date.now(),
      };
    }
    case REMOVE_SITE: {
      return {
        ...state,
        sites: state.sites.filter((s) => s.id !== action.siteId),
      };
    }
    case CLEAR_SITE_DATA: {
      return {
        ...structuredClone(initialState),
        // Kept across the reset.
        sites: state.sites,
        thumbnails: state.thumbnails,
        sitesLoadedAt: state.sitesLoadedAt,
      };
    }
    default: {
      return state;
    }
  }
}
